
import { defineComponent } from 'vue';

import { useStore } from 'vuex';

import ModalBody from '@/modules/modals/components/ModalBody.vue';
import ModalFooter from '@/modules/modals/components/ModalFooter.vue';
import ModalService from '@/modules/modals/services/modalService';

export default defineComponent({
    components: { ModalBody, ModalFooter },
    data() {
        return {
            modal: null
        };
    },
    setup() {
        const store = useStore();
        return {
            store
        };
    },
    mounted() {
        const modalElement = this.$refs.launchUserTutorialIntro;
        this.modal = ModalService.initialize(modalElement, this);
        ModalService.size(modalElement, '');
        ModalService.open(this.modal);
    },
    methods: {
        startTour() {
            ModalService.hide(this.modal);
            (this as any).eventBus.emit('launchUserTutorial');
        }
    }
});
